/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanionItem } from '../../models/companion-item';

export interface TravelControllerUpdateCompanion$Params {
  id: number;
      body: {
'picture'?: Blob;
'name'?: string;
'last_name'?: string;
'description'?: string;
'email'?: string;
}
}

export function travelControllerUpdateCompanion(http: HttpClient, rootUrl: string, params: TravelControllerUpdateCompanion$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanionItem;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerUpdateCompanion.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanionItem;
      }>;
    })
  );
}

travelControllerUpdateCompanion.PATH = '/travel/companion/{id}';
